// extracted by mini-css-extract-plugin
export default {"body_inner":"Layout-module__body_inner--9jzcj","main":"Layout-module__main--WCNY5"};